export default __webpack_public_path__ + "static/media/downloadIcon.85a219d0.svg";